import '../../../elements/color-button/color-button.js';
import '../../frame-selector/frame-selector';
import { defineElement, html, i18n } from '@webtides/element-js';
import CurrencyFormatter from '@zeg/base-light-module/frontend/js/helper/currency-formatter';
import bullsStyles from './bulls-product-card.css';
import BaseProductCard from '@zeg/base-light-module/frontend/components/structures/_product/product-card/product-card.class.js';
import {
    getFormattedDiscountPrice,
    isFromPrice,
    getFormattedStrikePrice,
    isStrikePrice,
    getFormattedSalePrice,
} from '@zeg/base-light-module/frontend/js/helper/price-model-helper';

class ProductCard extends BaseProductCard {
    constructor() {
        super({ styles: [bullsStyles] });
    }

    renderSaving() {
        if (!getFormattedDiscountPrice(this.currentFrame.prices)) {
            return '';
        }

        return html`
            <div
                class="frame-saving absolute leading-none right-0 bottom-0 mb-4 text-center text-grey-600 group-hover:text-white bg-grey-100 pl-10 pr-8 py-2 uppercase"
            >
                ${isFromPrice(this.currentFrame.prices) ? html` ${i18n('UP_TO')} ` : ''}
                ${getFormattedDiscountPrice(this.currentFrame.prices, true)} ${CurrencyFormatter.symbol()}
                ${i18n('productCard.saving', 'sparen')}
            </div>
        `;
    }

    renderPrice() {
        return html`
            <span class="product-card-price">
                ${!!isFromPrice(this.currentFrame.prices) ? `${i18n('FROM')} ` : ''}
                ${getFormattedSalePrice(this.currentFrame.prices)}<price-asterisk></price-asterisk>
            </span>
            ${!!getFormattedStrikePrice(this.currentFrame.prices)
                ? html`
                      <del>${getFormattedStrikePrice(this.currentFrame.prices)}</del> ${CurrencyFormatter.symbol()}
                      ${isStrikePrice(this.currentFrame.prices) ? i18n('RECOMMENDED_RETAIL_PRICE') : ''}
                  `
                : ''}
        `;
    }

    renderFrameSelector() {
        return html` <div class="text-center">${super.renderFrameSelector()}</div> `;
    }

    renderSpacerElement() {
        if (!this.showSpacerElement) return;
        return html`<div class="pt-12 xl:pt-8"></div>`;
    }

    template() {
        return html` ${super.template()} `;
    }
}

defineElement('product-card', ProductCard);
